<template>
  <project-filters
    :filters="filters"
    @click="setActiveFilterId"
  />
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { SET_ACTIVE_FILTER } from '@/store/mutation-types'
import ProjectFilters from '@/containers/Projects/ProjectFilters'

export default {
  components: {
    ProjectFilters
  },
  computed: {
    ...mapState({
      activeFilter: state => state.projects.activeFilter
    }),
    ...mapGetters(['filters'])
  },
  watch: {
    '$route.query' () {
      const { query = {} } = this.$route

      if (!query.filter && this.activeFilter !== -1) {
        this.setActiveFilter(-1)
      } else if (query.filter && (+query.filter !== this.activeFilter)) {
        this.setActiveFilter(query.filter)
      }
    }
  },
  created () {
    const { query = {} } = this.$route
    query.filter && this.setActiveFilter(query.filter)
  },
  methods: {
    ...mapMutations({
      setActiveFilter: SET_ACTIVE_FILTER
    }),
    setActiveFilterId (filter) {
      this.$router.replace({ query: { filter: filter.id } })
      this.setActiveFilter(filter.id)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Projects/ProjectFiltersContainer.vue